import React, { memo, useCallback } from "react";
import { Button } from "@chakra-ui/react";
import { IS_APPLE } from "modules/utils/Constants";
import colors from "app/colors";
import { ItalicIcon } from "modules/icons";
import { IQuillFormats } from "modules/quill/use-quill";

interface IProps {
  format: (name: string, value: any) => void;
  activeFormats: IQuillFormats;
}

const ComposeQuillItalic = ({ format, activeFormats }: IProps) => {
  const isSelected = !!activeFormats.italic;

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (format) {
        format("italic", !isSelected);
      }
    },
    [isSelected, format],
  );

  const bg = isSelected ? colors.gray0 : colors.transparent;

  return (
    <Button
      variant="hover"
      size="sm"
      aria-label="Format text as italic"
      title={IS_APPLE ? "Italic (⌘I)" : "Italic (Ctrl+I)"}
      tabIndex={-1}
      onMouseDown={onMouseDown}
      px={0}
    >
      <ItalicIcon boxSize={5} fill={colors.gray40} bg={bg} borderRadius={4} />
    </Button>
  );
};

export default memo(ComposeQuillItalic);
